import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Dropdown, Menu } from "antd";
import { FileExcelOutlined, FilePdfOutlined, FileTextOutlined } from "@ant-design/icons";
import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
import { ButtonItem, MensajeError } from "../../../../../Components/Items";
import { limpiarNombreArchivo } from "../../../../../Components/ExcelTablaReporte";
import reporteDiaProduccionPdf from "../../../../../Pdf/reporteDiaProduccionPdf";
import { descargarReporteDiaProduccion } from "./reporteDiaProduccion.utils";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const BotonReporteDiaProduccionPU = ({ desde, hasta, etiquetaRango, presupuestoPUId, flujoId }) => {
  const [cargando, setCargando] = useState(false);
  const empresaId = useSelector((state) => state.empresa.id);
  const empresaNombre = useSelector((state) => state.empresa.nombre);
  const headersToken = useSelector((state) => state.user.headersToken);
  const usuarioNombre = useSelector((state) => [state.user.nombre, state.user.apellidoPaterno, state.user.apellidoMaterno].filter(Boolean).join(" "));

  const consultar = (conEmpresa, alTerminar) => {
    setCargando(true);
    axios
      .post("ordenesDeProduccionPU/planeacionOrdenes", { empresaId, desde, hasta, presupuestoPUId, flujoId, conEmpresa }, { headers: headersToken })
      .then((res) => {
        setCargando(false);
        if (res.data.success !== 2) {
          MensajeError({ message: res.data.error || "No se pudo generar el reporte" });
          return;
        }
        const grupos = (res.data.grupos || []).filter((g) => g.ordenes.length > 0);
        if (grupos.length === 0) {
          MensajeError({ message: "No hay órdenes en este rango para reportar" });
          return;
        }
        alTerminar(grupos, res.data);
      })
      .catch(() => {
        setCargando(false);
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  const descargarExcel = () => consultar(false, (grupos) => descargarReporteDiaProduccion({ grupos, empresaNombre, etiquetaRango, usuarioNombre }));

  const descargarPdf = () =>
    consultar(true, (grupos, datos) =>
      pdfMake
        .createPdf(reporteDiaProduccionPdf({ grupos, empresa: datos.empresa || { nombre: empresaNombre }, etiquetaRango, usuarioNombre, ahora: datos.ahora }))
        .download(`${moment().format("DD MM YYYY")} Reporte_produccion_${limpiarNombreArchivo(etiquetaRango)}.pdf`)
    );

  const menu = (
    <Menu>
      <Menu.Item key="excel" icon={<FileExcelOutlined style={{ color: "#217346" }} />} onClick={descargarExcel}>
        Excel
      </Menu.Item>
      <Menu.Item key="pdf" icon={<FilePdfOutlined style={{ color: "#df0101" }} />} onClick={descargarPdf}>
        PDF
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <ButtonItem cyan botonAncho loading={cargando} icon={<FileTextOutlined />}>
        Reporte del día
      </ButtonItem>
    </Dropdown>
  );
};

export default BotonReporteDiaProduccionPU;
